import template from './target-list.html';
import controller from './target-list.controller';

let targetListComponent = {
  bindings: {},
  template,
  controller
};

export default targetListComponent;



// WEBPACK FOOTER //
// ./client/app/components/target/target-list.component.js